import { createMultiStyleConfigHelpers as e } from "@chakra-ui/react";
const i = e(["container"]), t = i.defineMultiStyleConfig({
  baseStyle: {
    container: {
      display: "inline-flex",
      gap: "8px",
      "> li": {
        display: "inline-block"
      },
      "> li:not(.previous):not(.next)": {
        display: "none"
      },
      "> li.disabled > a > div": {
        opacity: 0.5,
        cursor: "not-allowed",
        boxShadow: "none"
      },
      "> li.previous, li.next": {
        fontSize: "16px"
      },
      "li:not(.previous, .next)": {
        backgroundColor: "white",
        borderRadius: "lg",
        height: "32px",
        minWidth: "32px",
        mx: 1,
        my: 0,
        px: 1,
        py: 0
      },
      "li:not(.previous, .next) > a": {
        alignItems: "center",
        color: "gray.800",
        display: "flex",
        fontSize: "md",
        fontWeight: 700,
        height: "100%",
        justifyContent: "center"
      },
      "li:not(.previous, .next).selected > a, li:not(.previous, .next):hover > a": {
        color: "white"
      },
      "li:not(.previous, .next).selected, li:not(.previous, .next):hover": {
        bg: "teal.600",
        borderColor: "teal.600"
      }
    }
  }
});
export {
  t as default
};
